import { render, staticRenderFns } from "./SetPermissionsPage.vue?vue&type=template&id=a2f6fbfe&scoped=true"
import script from "./SetPermissionsPage.vue?vue&type=script&lang=js"
export * from "./SetPermissionsPage.vue?vue&type=script&lang=js"
import style0 from "./SetPermissionsPage.vue?vue&type=style&index=0&id=a2f6fbfe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f6fbfe",
  null
  
)

export default component.exports